@if (multi() && readonly()) {
    <si-pills-input
        [placeholder]="
            'components.application-detail-dashboard.application-additional-subject-areas.topics' | translate
        "
        [formControl]="peopleDisplayControl"
        [readonly]="readonly()"
    />
} @else {
    @let selectClass = multi() ? 'form-control' : 'form-control [&_.dropdown-caret]:hidden';
    @let clearButtonPosition = multi() ? 'right-5' : 'right-0';

    <div class="position-relative">
        @if (multi()) {
            <si-select
                [class]="selectClass"
                hasFilter
                multi
                closeOnScroll
                [formControl]="control()"
                [placeholder]="readonly() ? '' : (placeholder() | translate)"
                [optionSource]="personOptionsSource"
                [ariaLabel]="ariaLabel() | translate"
                [readonly]="readonly()"
                [class.is-invalid]="control().invalid && control().touched"
                (openChange)="onOpenChange($event)"
            />
        } @else {
            <si-select
                [class]="selectClass"
                hasFilter
                closeOnScroll
                [formControl]="control()"
                [placeholder]="readonly() ? '' : (placeholder() | translate)"
                [optionSource]="personOptionsSource"
                [ariaLabel]="ariaLabel() | translate"
                [readonly]="readonly()"
                [class.is-invalid]="control().invalid && control().touched"
                (openChange)="onOpenChange($event)"
            />
        }
        @if (hasClearableValue()) {
            <button
                type="button"
                class="btn btn-circle element-cancel position-absolute top-50 translate-middle-y"
                [class]="clearButtonPosition"
                [attr.aria-label]="'components.people-select.clear' | translate"
                (click)="clearSelection()"
            ></button>
        }
        @if (!readonly() && control().invalid && control().touched) {
            <div class="invalid-feedback d-block">
                {{ 'application-form.required' | translate }}
            </div>
        }
    </div>
}
